import { SwarovskiOptikLocale } from "@swo/shared";

export const getFallbackLocale = (
  locales: Array<SwarovskiOptikLocale>,
  fallbackLocaleCode: string,
): SwarovskiOptikLocale => {
  const matchingDefaultLocale = locales.find(locale => locale.code === fallbackLocaleCode);

  if (matchingDefaultLocale) {
    return matchingDefaultLocale;
  } else {
    throw new Error("No locales are available.");
  }
};
